import { setEventHandler } from "./eventHandler";

export default function setup(eventHandler) {
  setEventHandler(eventHandler);
}



// WEBPACK FOOTER //
// ./src/tracking/setup.js